import React, { useEffect, useState } from "react";
import Sheet from "@amzn/meridian/sheet";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close-medium";
import Text from "@amzn/meridian/text";
import { getPresignedUrl } from "../../upload/utils";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Alert from "@amzn/meridian/alert";

export const ImageSheet: React.FC<{
    imageHeader: string;
    s3ObjectIdList: string[];
    displayImage: boolean;
    index?: number;
    handleDisplayImage: (open: boolean, index?: number) => void;
}> = ({ imageHeader, s3ObjectIdList, displayImage, handleDisplayImage, index }) => {
    const [itemIndex] = useState(index);
    const [s3PresignedURLList, setS3PresignedURLList] = useState<
        { original: string; originalWidth: string; originalHeight: string }[]
    >([]);

    useEffect(() => {
        const fetchPresignedUrls = async () => {
            const urlPromises = s3ObjectIdList.map(async s3ObjectId => {
                return await getPresignedUrl(s3ObjectId);
            });
            const results = await Promise.all(urlPromises);

            const newUrlList = results.map(result => ({
                original: result,
                originalWidth: "900px",
                originalHeight: "900px",
            }));
            setS3PresignedURLList(newUrlList);
        };

        fetchPresignedUrls();
    }, [s3ObjectIdList]);

    const onClose = () => {
        itemIndex ? handleDisplayImage(false, itemIndex) : handleDisplayImage(false);
    };

    const handleCancel = () => {
        index || index === 0 ? handleDisplayImage(false, index) : handleDisplayImage(false);
    };

    return s3PresignedURLList.length === 1 && !s3PresignedURLList[0].original ? (
        <Sheet type="overlay" side="end" open={displayImage} onClose={onClose}>
            <Box width="100%">
                <Box height={"50px"} />
                <Row width="100%" alignmentHorizontal="end">
                    <Button onClick={handleCancel} type={"icon"}>
                        <Icon tokens={closeMediumTokens}></Icon>
                    </Button>
                </Row>
                <Box height={"10px"} />
                <Alert type="warning">
                    <Text type="h200">No image available!</Text>
                </Alert>
            </Box>
        </Sheet>
    ) : (
        <Sheet type="overlay" side="end" open={displayImage} onClose={onClose}>
            <Box width="100%">
                <Column overflowX={"scroll"}>
                    <Box height={"30px"} />
                    <Row widths={["fill", "fill"]} width="100%">
                        <Row width="100%" alignmentHorizontal="start">
                            <Text type={"h200"}>{imageHeader}</Text>
                        </Row>
                        <Row width="100%" alignmentHorizontal="end">
                            <Button onClick={handleCancel} type={"icon"}>
                                <Icon tokens={closeMediumTokens}></Icon>
                            </Button>
                        </Row>
                    </Row>
                    <Box height={"10px"} />
                    <ImageGallery
                        items={s3PresignedURLList}
                        infinite={false}
                        showIndex={true}
                        showBullets={true}
                        showPlayButton={false}
                    />
                </Column>
            </Box>
        </Sheet>
    );
};
